// Лёгкий конфиг ключей текстур луж — БЕЗ зависимостей от scale/platform/Player.
// Вынесен из systems/puddles.ts, чтобы BootScene мог импортировать список
// текстур, не активируя цепочку puddles → scale → platform → Player → scale.
// Через эту цепочку scale.ts инициализируется ПЕРЕД Player.ts, и Player.ts
// падает с TDZ "Cannot access 'PLAYER_SCALE' before initialization".
//
// Конвенция: ключ = имя файла без расширения. Файл лежит в public/assets/enemy/.
// Добавил врага с лужами → дописать одну строку в map. recordEnemyPuddle сам
// проверит наличие массива по id; нет → лужа не спавнится.
export const PUDDLES_BY_ENEMY: Record<string, string[]> = {
  rabbit: ['puddle_rabbit_hunched', 'puddle_rabbit_side'],
  mouse: ['puddle_mouse_sprawled', 'puddle_mouse_side'],
  boarling: ['puddle_boarling_1', 'puddle_boarling_2'],
  fox: ['puddle_fox_1', 'puddle_fox_2'],
  beetle: ['puddle_beetle_1', 'puddle_beetle_2'],
  deer: ['puddle_deer_1', 'puddle_deer_2'],
  kangaroo: ['puddle_kangaroo_1', 'puddle_kangaroo_2'],
  // Joey переиспользует ассеты кенгуру. baseSize в recordEnemyPuddle берётся
  // из config.size конкретного врага (joey 16 vs kangaroo 38), лужа joey
  // автоматически ~× 0.42 без отдельного PNG.
  kangaroo_joey: ['puddle_kangaroo_1', 'puddle_kangaroo_2'],
  wolf: ['puddle_wolf_1', 'puddle_wolf_2'],
  // Босс-кабан. Один вариант лужи — массив из одной строки, random выбор всё
  // равно отработает (рандом по индексу [0..0]). baseSize=100 (BIG_BOAR.size)
  // даёт лужу ~200 px на 720p — заметно крупнее обычных (волк 62, кенгуру 76).
  big_boar: ['puddle_big_boar_1'],
  // Босс-лось. baseSize=110 (ELK.size) → лужа ~220 px на 720p, чуть больше big_boar.
  elk: ['puddle_elk_1'],
  // Медоед. baseSize=80 (HONEY_BADGER.size) → лужа ~160 px на 720p — меньше
  // других боссов (медоед сам мельче), но заметно крупнее обычных врагов.
  // Записывается на ВТОРОЙ смерти, после performRevive (первый раз —
  // handleBossFakeDeath без dieWithKnockback).
  honey_badger: ['puddle_honey_badger_1'],
  // Заражённый верблюд. baseSize=105 (CAMEL.size) → лужа ~210 px на 720p,
  // между elk (220) и big_boar (200). reviveOnce у верблюда нет → одна
  // смерть = одна лужа.
  camel: ['puddle_camel_1'],
  // Медведь — финальный босс. baseSize=120 (BEAR.size) → лужа ~240 px,
  // самая крупная. Лужа записывается ДО показа showFinalVictory (через
  // dieWithKnockback), остаётся на сцене до перехода обратно.
  bear: ['puddle_bear_1'],
};

// Для BootScene preload — плоский список всех ключей, чтобы дёрнуть load.image
// один раз без вложенных циклов.
export const ALL_PUDDLE_KEYS = Object.values(PUDDLES_BY_ENEMY).flat();

// Прозрачность луж — притопляет декаль под траву. Применяется только к
// puddle-Image (см. systems/puddles.ts), на яркость врагов/боссов не влияет.
// 0.85 = еле заметно, 0.7 = заметно (норма), 0.5 = сильно просвечивает.
export const PUDDLE_ALPHA = 0.7;
